import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const docFolderLocaleModule: LocaleModule = {
  name: "docFolder",
  messages: { en: en, it: it },
};
